import { Box, Spacer } from "@chakra-ui/react";


export default function Career(){
    return (
        <Box>
            <Spacer h={"150px"}/>
            Career
        </Box>
    )
}